<template>
  <div class="modal_history_call">
    <pulse-loader :loading="loading" :color="globalLoadingColor" class="text-center"/>
    <div v-if="localCalls.length || allCalls.length">
      <h6 class="m-0">История звонков</h6>
      <div class="text-right" v-if="totalExtraCalls">
        <input v-model="showAll" @change="updateList" type="checkbox" name="" id="ch_11">
        <label class="pointer" for="ch_11">Показать все звонки по клиенту</label>
      </div>
      <div v-bind:class="{ short_list: longList && !showFullList }">
        <div v-for="call in getCallsList()" :key="call.id"
             :class="{'card p-2 overflow-hidden':true,'text-muted': call.call_duration < 15}">
          <div v-if="call.call_duration < 15" class="corner-ribbon top-right sticky gray shadow">
            без ответа
          </div>
          <p>
            <template v-if="call?.user">
              <span>({{ call.user_id }}) <span v-if="call.user">{{ call.user.name }}</span></span>
            </template>
            <span class="text-muted">{{ printDate(call.created_at, 'DD.MM.YYYY HH:mm') }} ({{ call.id }})</span>
          </p>
          <div>
            <span v-if="call.notOrder" class="badge badge-dark valign-top">другой звонок</span>
            <i
              v-bind:class="{
                'icon-fa': true,
                'icon-fa-arrow-circle-left green': call.type_id === 1,
                'icon-fa-arrow-circle-right blue': call.type_id === 2
              }"
            ></i>
            {{ call.phone_title || 'не определен' }} =>
            {{ call.destination || 'не определен' }}
            <span class="badge badge-info valign-top">
              {{ call.ip_phone && call.ip_phone.description }}
            </span>
            <span v-if="!call.file_link"><strong>{{ call.call_duration }}c.</strong></span>
            <span v-if="call.status && +call.status !== 1" class="valign-top badge badge-success">A {{
                call.status
              }}</span>
          </div>
          <audio controls v-if="call.file_link">
            <source
              :src="`https://admin.rancond.info/api/noa/mangoRecord/${call.id}`"
              type="audio/mpeg"
            />
            Your browser does not support the audio tag.
          </audio>
        </div>
      </div>
      <div v-if="longList">
        <span class="pointer underline" @click="showFullList = !showFullList">{{
            showFullList ? 'Скрыть' : 'Показать все'
          }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'

export default {
  props: ['phone', 'orderId'],
  computed: {
    $phoneLines() {
      return this.$store.getters['platform/phoneLines']
    },
    $userPhoneNumbers() {
      const availablePhones = this.$store.getters[
        'user/phoneNumbers'
        ].numbers.reduce((acc, p) => {
        acc[p.line_number] = {...p}
        return acc
      }, {})
      return availablePhones
    },
    $AllProjects() {
      const projects = this.$store.getters['platform/projects'].reduce(
        (acc, p) => {
          acc[p.id] = {...p}
          return acc
        },
        {}
      )
      return projects
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    }
  },
  data() {
    return {
      showFullList: false,
      longList: false,
      showAll: false,
      totalExtraCalls: 0,
      localCalls: [],
      allCalls: [],
      calls: [],
      loading: false,
      localPhone: null,
    }
  },
  watch: {
    'phone': {
      handler: function (val, oldVal) {
        if (this.phone.full_phone !== this.localPhone.full_phone) {
          this.localPhone = {...this.phone}
          setTimeout(() => {
            this.getPhoneHistory()
          }, 300)
        }
      },
      deep: true
    },
  },
  mounted() {
    this.localPhone = {...this.phone}
  },
  methods: {
    getCallsList() {
      return _.orderBy(this.showAll ? [...this.allCalls, ...this.localCalls] : this.localCalls, 'id', 'desc');
    },
    async getPhoneHistory() {
      this.calls = []
      this.allCalls = []
      this.localCalls = []
      if (!this.localPhone || !this.localPhone.valid || !this.localPhone.full_phone) return
      this.loading = true
      const {data} = await api.index('/telephony/history?t=' + (this.localPhone.full_phone || '').replace(/\D/g, '') + '&oId=' + this.orderId)
      if (!data.success) {
        toastr['warning'](data.message || 'ошибка сервера', 'Подгрузка истории звонков')
      } else {
        this.localCalls = data.orders_phones.reduce((acc, c) => {
          if (c.phone_call.client_phone_id === this.phone.phone_id) {
            acc.push({
              ...c.phone_call,
              status: c.status,
            });
          }
          return acc;
        }, []);

        const ids = data.orders_phones.map((c) => c.phone_call_id);

        if (data.calls) {
          this.allCalls = data.calls.reduce((acc, c) => {
            if (!ids.includes(c.id)) {
              acc.push({...c})
            }
            return acc
          }, [])
          // this.allCalls = [...this.calls]
        }
        if (data.calls.length > 5) {
          this.longList = true
        } else {
          this.longList = false
        }
        // this.totalExtraCalls = this.calls.length !== this.allCalls.length;
        this.totalExtraCalls = !!this.allCalls.length;
      }
      this.loading = false
    },
    updateList() {
      // if (this.showAll) {
      //   this.localCalls = [...this.allCalls]
      // } else {
      //   this.localCalls = [...this.calls]
      // }
    },
    getCallData(call) {
      let text = 'Не определен'
      const line = call.type_id === 1 ? this.$phoneLines[call.destination] : this.$phoneLines[call.phone_title]
      if (line) {
        text = this.$AllProjects[line.project_id].name + '(' + line.phone_title + ')'
      }
      return text
    }
  }
}
</script>

<style scoped>
.valign-top {
  vertical-align: text-top;
}

.short_list {
  max-height: 210px;
  overflow: hidden;
}

.text-muted {
  font-size: 10px;
}

.icon-fa.green {
  color: #4fc47f;
}

.icon-fa.blue {
  color: #02a2f8;
}

audio {
  height: 25px;
}

p {
  margin-bottom: 2px;
}
</style>
